import { Card } from '../components/Card'
import { VerifyAppFlow } from '../components/VerifyAppFlow'

/**
 * Step 3 of 4 / Returning Login: Authenticator App TOTP Verification.
 * Ported from the web client's `/login/verify-app` page. The {@link VerifyAppFlow}
 * leaf owns the Step 3 → Step 4 (backup codes) transition.
 */
export function VerifyAppPage() {
  return (
    <Card>
      <VerifyAppFlow />
    </Card>
  )
}
